
import { AIAnswerComponent } from "@/lib/model/exambuilder/exam-component/aiAnswer";
interface ListItem {
  checked: boolean;
  questionNo: string;
  shortName: string;
  standardAnswer: string;
}
export default {
  name: "DialogForQuestion",
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      loading: false,
      localVisible: false,
      list: [] as ListItem[]
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    getList: {
      type: Function,
      required: true
    },
    link: {
      type: Array,
      required: true
    }
  },
  computed: {
    selectedList(): Array {
      return this.list?.filter(el => el.checked);
    }
  },
  methods: {
    reset() {
      this.list = [];
      this.localVisible = false;
    },
    handCheck(item) {
      console.log("item: ", item);
    },
    addQuestion() {
      this.getList(this.selectedList);
      this.reset(); // 清空数据，恢复初始
    },
    // 点击移除
    handleDelete(key) {
      const obj = this.list.find(item => item.questionNo === key);
      obj.checked = false;
    },
    // 通过link过滤掉已在问题库中的list
    filterList(_list) {
      const list = _list.filter(ele => {
        return !this.link.find(el => el.qaId === ele.id);
      });
      return list;
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.localVisible = newVal;
      const getList = async () => {
        this.loading = true;
        const res = await AIAnswerComponent.get();
        this.list = this.filterList(res.list || []);
        this.loading = false;
      };
      // 如果弹窗出现则拉接口
      if (newVal) {
        getList();
      }
    }
  }
};
